// extracted by mini-css-extract-plugin
module.exports = {"list":"ListContainer_list__3NGQM"};